import * as institutionInsurancesActions from '../actions/institution-insurances.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { copy } from '../../../../shared/utils/functions/copy.function';

export interface InstitutionInsurancesState {
    institutionInsurancesValues: any;
    loading: boolean;
    loaded: boolean;
}

const initialState = {
    institutionInsurancesValues: null,
    loading: false,
    loaded: false,
}

export const institutionInsurancesReducer = (state = initialState, action) => {
    switch(action.type) {
        case institutionInsurancesActions.GET_INSTITUTION_INSURANCES_LIST:
            return {
                ...state,
                loading: true,
                loaded: state.loaded
            };
        case institutionInsurancesActions.GET_INSTITUTION_INSURANCES_LIST_SUCCESS:
            return {
                ...state,
                institutionInsurancesValues: action.payload,
                loading: false,
                loaded: true,
            };
        case institutionInsurancesActions.GET_INSTITUTION_INSURANCES_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false,
            };
        default:
            return state;
    }
}

export const getInstitutionInsurancesState =
    createFeatureSelector<InstitutionInsurancesState>('institutionInsurancesReducer');

export const getInstitutionInsurancesList = (state: InstitutionInsurancesState) => state.institutionInsurancesValues;
export const getInstitutionInsurancesListLoaded = (state: InstitutionInsurancesState) => state.loaded;
